import { lazyPipe, validateApiResponse, withApiErrorCapture } from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import { z } from 'zod';
import { createApiResponseSchema } from '../../../utils';
import { partnerApiPath } from '../../apiPath';
import { partnerHttpClient } from '../../httpClient';

const GetSeedingTermsAgreementResponseDataSchema = z
  .object({
    agreed: z.boolean().describe('약관 동의 여부 (false 시 약관 동의 화면 노출)'),
  })
  .describe('GetSeedingTermsAgreementResponseDataSchema');

export type GetSeedingTermsAgreementResponseData = z.infer<
  typeof GetSeedingTermsAgreementResponseDataSchema
>;

const GetSeedingTermsAgreementResponseSchema = createApiResponseSchema(
  GetSeedingTermsAgreementResponseDataSchema,
);

export type GetSeedingTermsAgreementResponse = z.infer<
  typeof GetSeedingTermsAgreementResponseSchema
>;

export const getSeedingTermsAgreement = withApiErrorCapture(
  lazyPipe(
    async () =>
      executeStandardRequest(async () =>
        partnerHttpClient.get<GetSeedingTermsAgreementResponse>(
          partnerApiPath.seedingTermsAgreement,
        ),
      ),
    validateApiResponse(GetSeedingTermsAgreementResponseSchema),
  ),
);
